import { Log, UserManager } from 'oidc-client-ts';
import { env } from '~/env';

export const handleLoginRedirect = () => {
    const { runtimeConfig } = env;
    const runsInIframe = window?.parent && window.parent !== window;

    if (runsInIframe) {
        // Silent redirect within an <iframe>
        Log.setLogger(console);
        Log.setLevel(Log.INFO);

        // This will propagate the received information provided via
        // query parameters to the parent frame
        new UserManager({
            authority: `${runtimeConfig.login.authority}`,
            client_id: `${runtimeConfig.login.clientId}`,
            redirect_uri: `${runtimeConfig.login.redirectUri}`,
            filterProtocolClaims: false,
        }).signinSilentCallback();
    } else {
        // Full redirect — navigate to /#/redirected which triggers attemptInitialSignIn
        window.location.replace(`${window.location.origin}#/redirected`);
    }
};
